function escapeOnErrorCode(text: string): string {
    let resultStr = text;

    const onErrorRegex = /onerror\s*=\s*"(.*?)"/gi;
    resultStr = resultStr.replace(onErrorRegex, "");

    return resultStr;
}


export default escapeOnErrorCode;
